package ai.flowstorm.studio.ui.data

import ai.flowstorm.common.setProperty
import ai.flowstorm.common.ui.EntityTable
import ai.flowstorm.studio.model.User
import ai.flowstorm.studio.resources.UserResource
import io.kvision.i18n.I18n.tr
import io.kvision.modal.ModalSize
import io.kvision.tabulator.ColumnDefinition
import io.kvision.tabulator.Layout
import io.kvision.tabulator.TabulatorOptions
import io.kvision.utils.obj
import io.kvision.utils.px


class ProfileRecordUserTable : EntityTable<User>(
    caption = "User Profile Record",
    model = UserResource,
    tabulatorOptions = TabulatorOptions(
        layout = Layout.FITCOLUMNS,
        columns = listOf(
//            ColumnDefinition(tr("Id"), User::id.name, width = "20%"),
            ColumnDefinition(tr("Username"), User::username.name, width = "30%"),
            ColumnDefinition(tr("Name"), User::name.name, width = "20%"),
            ColumnDefinition(tr("Surname"), User::surname.name, width = "20%"),
            ColumnDefinition(tr("Nickname"), User::nickname.name, width = "30%"),
        ),
    ),
    dataExtractor = {
        obj {
//            setProperty(this, it::id)
            setProperty(this, it::username)
            setProperty(this, it::name)
            setProperty(this, it::surname)
            setProperty(this, it::nickname)
        }
    },
    entityComponentFactory = { ProfileRecordUserViewer(UserResource) },
    filterFormFactory = { ProfileRecordUserFilterForm() },
    tabWidth = 450.px,
    splitMode = true,
    seekEnabled = true,
    searchEnabled = true,
    saveEnabled = false,
    deleteEnabled = false,
    modalSize = ModalSize.LARGE,
    hideHeader = false,
    className = "content-panel",
)